import styled from 'styled-components';

import { Box, Text, spaces } from '@electricjs/arc';

const List = styled.ul`
  margin: ${spaces.space_2xs} 0 0 ${spaces.space_s};
  padding: 0;
`;

type EnumValuesListProps = {
  title: string;
  values: { value: string; label: string }[];
};

export const EnumValuesList = ({ title, values }: EnumValuesListProps) => (
  <Box>
    <Text variant="label-small">{title}</Text>
    <List>
      {values.map(({ value, label }) => (
        <li key={value}>
          {/* Displaying the "label", because the user will type this label instead of the value in the CSV file */}
          <Text variant="legal">{label}</Text>
        </li>
      ))}
    </List>
  </Box>
);
